"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var dialog_1 = require("@material/dialog");
require("../button");
//@ts-ignore
require("../theme.ts");
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onScrim = function (e) { _this.fire('scrim', e); };
        _this.onCancel = function (e) { _this.fire('cancel', e); };
        _this.onConfirm = function (e) { _this.fire('confirm', e); };
        return _this;
    }
    Dialog.prototype.updated = function () {
        this.props.show ? this.dialog.open() : this.dialog.close();
    };
    Dialog.prototype.installed = function () {
        var _this = this;
        this.dialog = new dialog_1.MDCDialog(this.shadowRoot.querySelector('.mdc-dialog'));
        this.props.show ? this.dialog.open() : this.dialog.close();
        this.dialog.listen('MDCDialog:opening', function (e) { _this.fire('opening', e); });
        this.dialog.listen('MDCDialog:opened', function (e) { _this.fire('opened', e); });
        this.dialog.listen('MDCDialog:closing', function (e) { _this.fire('closing', e); });
        this.dialog.listen('MDCDialog:closed', function (e) { _this.fire('closed', e); });
    };
    Dialog.prototype.render = function (props) {
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'mdc-dialog', {
            'mdc-dialog--scrollable': props.scrollable
        })),
            omi_1.h("div", { class: 'mdc-dialog__scrim', onClick: this.onScrim }),
            omi_1.h("div", { class: 'mdc-dialog__container' },
                omi_1.h("div", { class: 'mdc-dialog__surface' },
                    props.title && omi_1.h("h2", { class: 'mdc-dialog__title' }, props.title),
                    omi_1.h("section", { class: 'mdc-dialog__content' },
                        omi_1.h("a", { class: 'm-dialog-content-focus', href: "#" }),
                        "  ",
                        omi_1.h("slot", null)),
                    (props.cancelButton || props.confirmButton) &&
                        omi_1.h("footer", { class: 'mdc-dialog__actions' },
                            props.cancelButton && omi_1.h("m-button", __assign({ onClick: this.onCancel, ripple: true }, props.cancelButton), props.cancelButton.text),
                            props.confirmButton && omi_1.h("m-button", __assign({ onClick: this.onConfirm, ripple: true }, props.confirmButton), props.confirmButton.text))))));
    };
    Dialog.css = css;
    Dialog.propTypes = {
        show: Boolean,
        scrollable: Boolean,
        title: String,
        cancelButton: Object,
        confirmButton: Object
    };
    Dialog = __decorate([
        omi_1.tag('m-dialog')
    ], Dialog);
    return Dialog;
}(omi_1.WeElement));
var dom;
Dialog.confirm = function (options) {
    if (dom) {
        document.body.removeChild(dom);
    }
    dom = omi_1.render(omi_1.h("m-dialog", { "cancel-button": { text: options.cancelText || 'Cancel' }, "confirm-button": { text: options.confirmText || 'Confirm' }, onCancel: function (_) { return onConfirm(options.cancel); }, onConfirm: function (_) { return onConfirm(options.confirm); }, show: true },
        omi_1.h("p", { style: 'margin:0' }, options.msg)), 'body');
};
function onConfirm(callback) {
    callback && callback();
    if (dom) {
        document.body.removeChild(dom);
        dom = null;
    }
}
Dialog.alert = function (options) {
    if (dom) {
        document.body.removeChild(dom);
    }
    dom = omi_1.render(omi_1.h("m-dialog", { "confirm-button": { text: options.confirmText || 'Confirm' }, onConfirm: function (_) { return onConfirm(options.confirm); }, show: true },
        omi_1.h("p", { style: 'margin:0' }, options.msg)), 'body');
};
exports.default = Dialog;
